import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Award, Users, Skull, Moon, Gift, ScrollText, Sparkles } from "lucide-react";
import T from "@/components/T";

const KIND_ICON = {
  title: Award,
  guild: Users,
  worldboss: Skull,
  event: Moon,
  referral: Gift,
  recruit: ScrollText,
  legendary: Sparkles,
};
const KIND_COLOR = {
  title: "#B89C3A",
  guild: "#4A7BC7",
  worldboss: "#8A0303",
  event: "#E33333",
  referral: "#E5C34A",
  recruit: "#6E8B3D",
  legendary: "#E33333",
};

function timeAgo(iso) {
  const d = new Date(iso);
  const s = Math.max(0, (Date.now() - d.getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
}

export default function FeedView() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const refresh = () => api.feed().then(setItems).catch(() => {});
    refresh();
    const t = setInterval(refresh, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="panel p-2" data-testid="feed-view">
      <div className="px-2 py-1 flex items-center justify-between">
        <span className="font-heading text-xs tracking-[0.3em] uppercase text-[#8c8c8c]">
          <T>World Chronicle</T>
        </span>
        <span className="font-mono text-[10px] text-[#666]">{items.length} entries</span>
      </div>
      <div className="max-h-[70vh] overflow-y-auto space-y-1">
        {items.length === 0 && (
          <p className="italic text-[#666] text-xs px-2 py-3"><T>The world holds its breath.</T></p>
        )}
        {items.map(f => {
          const Icon = KIND_ICON[f.kind] || Award;
          const color = KIND_COLOR[f.kind] || "#8c8c8c";
          return (
            <div
              key={f.feed_id}
              data-testid={`feed-${f.feed_id}`}
              className="panel-inner p-2 flex items-start gap-2 fade-up"
            >
              <Icon className="w-3 h-3 mt-1 shrink-0" style={{ color }} strokeWidth={1.5} />
              <div className="min-w-0 flex-1">
                <div className="text-xs">
                  <span className="font-heading text-[#E5C34A] tracking-wider">{f.user_name}</span>{" "}
                  <span className="text-[#B0ADA5]">{f.text}</span>
                </div>
                <div className="font-mono text-[9px] text-[#666] uppercase tracking-widest mt-0.5">
                  {f.kind} · {timeAgo(f.at)} ago
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
